import BeenhereIcon from '@mui/icons-material/BeenhereRounded';
import CategoryIcon from '@mui/icons-material/Category';
import StyledTypography from './styles';

export default function TopicTag(props: { topic: string, color?: string | null, isCompliance?: boolean, showIcon?: boolean }) {
  const {
    topic, color, isCompliance, showIcon,
  } = props;

  return (
    <StyledTypography color={color}>
      {isCompliance && <BeenhereIcon className="icon" />}
      {showIcon && <CategoryIcon />}
      {topic}
    </StyledTypography>
  );
}
